<style scoped> 
.solution-chip:not(.smsfinans) {
    background: linear-gradient(105.34deg, #91DC60 43.18%, #3DAE2B 162.31%);
    border-radius: 8px ;
}
</style>

<template>
    <div class="d-inline">
        <Counter
            :value="count"
            @click="isHidden=!isHidden"  
            style="cursor: pointer"
            />                

        <scroll-y-reverse-transition>
            <!-- <v-overlay v-if="isHidden"> -->
            <v-card 
                light 
                v-if="!isHidden" 
                style="position: absolute; right: 50px; top:0; z-index: 1000;"
                height="315"
                width="357"
                >
                <v-card-title>
                    <Counter
                        :value="count"
                        small  
                        /> 
                    <div 
                        @click="isHidden=!isHidden"
                        style="position: absolute; right: 16px; top: 16px; cursor: pointer"
                        >
                        <img src="./../../assets/close.png" >
                    </div>
                </v-card-title>
                <v-card-text class="pt-2">
                    <div
                        :class="{ smsfinans: $CLObject.type == 'smsfinans' }"
                        class="solution-chip py-2 pl-4"                   
                        >
                        &bull; <span class="pl-4">Вам одобрил заявку <b>CreditPlus</b></span>
                    </div>
                </v-card-text>
            </v-card>
        <!-- </v-overlay> -->
        </scroll-y-reverse-transition>
    </div>
</template>

<script>
import Counter from './Counter.vue';

export default {
    components: { Counter },
    mounted() {
        let checkBankInfo = () => {
            // this.count++; v 
            this.$connector.ApplicationBankInfo().then(
                data => {
                    console.log("banksInfo", data?.banksInfo);
                }
            )
        };

        this.interval = setInterval( checkBankInfo, 5000 );
    },
    destroyed() {
        clearInterval( this.interval );
    },
    data: () => ({
        isHidden: true,
        count: 1,
        interval: null
    }),
}
</script>